import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ClientUrlForm from "components/Admin/ClientUrls/ClientUrlForm";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "services/userInputFormatter";

const { EDIT_CLIENT_URL_SAGA } = constants;

const {
  loadClientUrlSagaAdmin,
  editClientUrlSaga,
  setTempClientUrl,
  loadClientUrlWebinarsSagaAdmin,
  addValidateError,
  cleanErrors,
} = actions;

class EditClientUrl extends Component {
  static propTypes = {
    editClientUrl: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);

    let clientUrl = this.props.clientUrl;

    this.state = {
      clientUrl: {
        name: "",
        slug: "",
        webinar_ids: [],
        ...clientUrl,
      },
    };
  }

  componentWillReceiveProps(props) {
    if (!_.isEmpty(props.clientUrl) && !_.isEqual(this.props.clientUrl, props.clientUrl)) {
      const webinar_ids = props.clientUrl.webinar_ids;

      this.setState({
        clientUrl: {
          ...this.state.clientUrl,
          ...props.clientUrl,
          webinar_ids,
        },
      });
    } else if (
      props.location.state &&
      props.location.state.from === "addWebinars"
    ) {
      this.setState({
        clientUrl: {
          ...this.state.clientUrl,
          ...props.temp,
        },
      });
    }
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.loadClientUrl(this.props.params.id);
    this.props.loadWebinars(this.props.params.id);
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const clientUrlData = {
      ...this.state.clientUrl,
      ...{
        [e.target.name]: input,
      },
    };

    this.setState({ clientUrl: clientUrlData });
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.editClientUrl(this.state.clientUrl);
  };

  goToAddWebinarsPage = () => {
    this.props.setTemp(this.state.clientUrl);
    this.props.router.push(`/client-url/${this.state.clientUrl.id}/edit/add-webinars`);
  };

  render() {
    const { errors, errorsFrontend, role, webinars } = this.props;

    return (
      <main className="site--width clearfix-c">
        <h2 className="main_title">Client Url #{this.state.clientUrl.id}</h2>
        <ClientUrlForm
          onFieldChange={this.onFieldChange}
          client_url={this.state.clientUrl}
          onSubmit={this.onSubmit}
          errors={validator.formatErrors(errors, errorsFrontend)}
          role={role}
          goToAddWebinarsPage={this.goToAddWebinarsPage}
          webinars={webinars}
          isEdit
        />
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  temp: state.clientUrls.admin.temp,
  webinars: state.clientUrls.admin.webinars,
  role: state.users.user.role,
  errors: state.errors[EDIT_CLIENT_URL_SAGA],
  errorsFrontend: state.errors[`${EDIT_CLIENT_URL_SAGA}_FRONTEND`],
  clientUrl: state.clientUrls.admin.clientUrl,
});

const mapDispatchToProps = (dispatch) => ({
  loadClientUrl: (id) => dispatch(loadClientUrlSagaAdmin(id)),
  editClientUrl: (user) => dispatch(editClientUrlSaga(user)),
    setTemp: (clientUrl) => dispatch(setTempClientUrl(clientUrl)),
  loadWebinars: (id) => dispatch(loadClientUrlWebinarsSagaAdmin(id)),
  validateUser: (errors) =>
    dispatch(addValidateError(EDIT_CLIENT_URL_SAGA, errors)),
  cleanErrors: () => dispatch(cleanErrors(EDIT_CLIENT_URL_SAGA)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditClientUrl);



// WEBPACK FOOTER //
// ./src/containers/Admin/ClientUrls/EditClientUrl.jsx